module.exports = __webpack_public_path__ + "img/pump-offline.a6869433.png";